import { theme } from '../../app/Theme'

export const styles = {
  container: {
    padding: theme.spacing(4),
    textAlign: 'center'
  }
}
